<template>
    <div class="row finish-investment">
        <!-- :::::::::::::::::: -->
        <div class="col-12">
            <div class="tit_page">
                <h1>
                    Confirmação de investimento
                </h1>
                <div class="clearfix"></div>
                <hr class="divider">
            </div>
        </div>

        <div class="col-12">
            <!-- Botões -->
            <div class="row btn-container">
                <div class="col-lg-4 col-xl-4 col-ms-12 col-12 container-back">
                    <a @click="Redirect('lista')" class="btn btn-back" target="_blank">
                        Ver Outras Oportunidades
                    </a>
                </div>
                <div class="col-lg-4 col-xl-4 col-ms-12 col-12 container-submit">
                    <button id="buttonSubmit" @click="SubmitInvestment" class="btn btn-submit" target="_blank">
                       CONFIRMAR INVESTIMENTO
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="white col-12 col-lg-12 col-xl-12">
                    <!-- Tabela -->
                    <div class="box-col-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="align-middle text-center" width="80">
                                        Score
                                    </th>
                                    <th scope="col" class="align-middle text-center" width="80">
                                        ID
                                    </th>
                                    <th scope="col" class="align-middle text-center" width="200">
                                        Tipo
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        Tomador
                                    </th>
                                    <th scope="col" class="align-middle text-center" width="120">
                                        Rendimento
                                    </th>
                                    <th scope="col" class="align-middle text-center" width="200">
                                        Valor Investimento
                                    </th>
                                    <!-- <th scope="col" width="120">
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="solicitacao != null"
                                    :class="ScoreClass(this.score)"
                                >
                                    <td class="rating align-middle text-center">
                                        <span class="circle side-circle"></span> {{score}}
                                    </td>
                                    <td class="align-middle text-center">
                                        {{solicitacao.IdOportunidade}}
                                    </td>
                                    <td class="align-middle text-center">
                                        {{TipoInvestimento()}}
                                    </td>
                                    <td class="align-middle text-center">
                                        {{NomeTomador()}}
                                    </td>
                                    <td class="align-middle text-center">
                                        {{solicitacao.Rendimento}}% a.a
                                    </td>
                                    <td class="align-middle text-center">
                                        {{FormatCurrency(this.Valor)}} <i @click="Redirect('perfil')" class="far fa-edit clk"></i>
                                    </td>
                                    <!-- <td class="align-middle text-center">
                                        Remover <i class="far fa-trash-alt"></i>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Card -->
                    <div class="card">
                        <div :class="ScoreClass(this.score)" class="card-img-top card-background">
                            <div class="badge badge-id">ID: {{solicitacao.IdOportunidade}}</div>
                            <h2>{{NomeTomador()}}</h2>
                            <div class="rating">
                                <span class="circle">{{score}}</span>
                            </div>
                        </div>
                        <div :class="ScoreClass(this.score)" class="card-body">
                            <dd class="cat">{{TipoInvestimento()}}</dd>
                            <dt>Valor à Pagar</dt>
                            <dd class="value">{{FormatCurrency(this.Valor - this.ValorReinv)}}</dd>
                            <dt v-if="FormatCurrency(this.ValorReinv)!='0,00'">Valor Reinvestido</dt>
                            <dd v-if="FormatCurrency(this.ValorReinv)!='0,00'" class="value">{{FormatCurrency(this.ValorReinv)}}</dd>
                            <dd>
                                <p class="small">Total investido:
                                    <strong>{{FormatCurrency(this.Valor)}}</strong>
                                </p>
                            </dd>
                        </div>
                        <div class="card-footer d-flex justify-content-between">
                            <div class="tax">
                                <strong>Rendimento</strong>
                                <span> {{solicitacao.Rendimento}}% a.a</span>
                            </div>
                            <div class="links">
                                <a @click="Redirect('perfil')" class="btn btn-outline-primary btn-block" title="+ detalhes">+ detalhes</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Submenu -->
            <div class="row paymentBox">
                <div class="col-lg-5 col-xl-5 col-ms-6 col-12">
                    <div class="gray paymentBox_table box-col-list">
                        <table class="table">
                            <thead v-if="FormatCurrency(this.ValorReinv)!='0,00'">
                                <tr>
                                    <th scope="col" class="paymentBox-tit align-middle text-left">
                                        Reinvestimento
                                    </th>
                                    <th scope="col" class="paymentBox-tit align-middle text-right">
                                        {{FormatCurrency(this.ValorReinv)}}
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" class="paymentBox-tit align-middle text-left">
                                        Valor do boleto
                                    </th>
                                    <th scope="col" class="paymentBox-tit align-middle text-right">
                                        {{FormatCurrency(this.Valor - this.ValorReinv)}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="paymentBox-contt align-middle text-left">
                                        Total investido
                                    </td>
                                    <td class="total-value paymentBox-contt align-middle text-right" >
                                        {{FormatCurrency(this.Valor)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Botões -->
            <div class="row btn-container">
                <div class="col-lg-4 col-xl-4 col-ms-12 col-12 container-back">
                    <a @click="Redirect('lista')" class="btn btn-back" target="_blank">
                        Ver Outras Oportunidades
                    </a>
                </div>
                <div class="col-lg-4 col-xl-4 col-ms-12 col-12 container-submit">
                    <a @click="SubmitInvestment" class="btn btn-submit" target="_blank">
                        CONFIRMAR INVESTIMENTO
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    .total-value{
        font-size:1.4em !important;
    }

    .box-col-table {
        display:block;
    }

    .card {
        display:none;
    }

    .container-submit{
        justify-content: flex-end;
        display: flex;
        .btn-submit{
            font-weight: bold;
        }
    }

    .container-back{
        justify-content: flex-start;
        display: flex;
    }

    @media (max-width: 900px) {
        .container-submit{
            margin: 10px;
            justify-content: center;
            display: flex;

            .btn-submit{
                margin-left:-20px;
                width: 100%;
            }
        }

        .container-back{
            margin: 10px;
            justify-content: center;
            display: flex;

            .btn-back{
                margin-left:-20px;
                width: 100%;
            }
        }

        .box-col-table {
            display:none;
        }

        .card {
            display:block;
        }
    }

    .card-img-top {
        margin: 15px;

        .rating {
            display: flex;
            justify-content: center;
            margin-left: -15px;
            margin-top: 15px;
        }
    }

    .clk {
        cursor: pointer;
    }

    .paymentBox{
        &{
            flex-direction: column;
            align-items: flex-end;
        }

        &_table{
            margin:20px;
            margin-right:0;
            padding:5px 20px;
            border: 1px solid #fff;
            border-radius: 5px;

            @include md {
                margin: 10px 0 0 0 !important;
            }

            @include xs {
                margin: 10px 0 0 0 !important;
            }
        }

        &-tit{
            font-weight: 200;
            font-size: 14px;
        }

        &-contt{
            font-weight: 500;
            font-size: 18px;
            color:#02ACEF;
        }
    }

    .btn{
        &-container{
            justify-content: space-between;
            margin-bottom: 40px;
        }

        &-submit{
            background-color: #40CD28;
            color:#fff
        }

        &-back{
            border: 1px solid #999;
            color: #999
        }
    }

    .side-circle{
        width: 12px !important;
        height: 12px !important;
        display: inline-flex !important;
    }

    .gray {
      @include brkp-01(1199px) {
        margin-top: 1rem;
      }
    }

    .table {
        &{
            margin: 0;
        }

        th {
            border: none !important;
        }

        tr {

            &{
                border-bottom:1px solid #e9ecef !important;
            }

            &:last-child {
                border: none !important;
            }
        }
    }

    .tit_page {
        &{
            margin-bottom: 30px;
        }

        h1 {
            font-size: calcRem(30);
        }
    }

    .sec_tit {

        &{
            margin-top: 30px;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 1px solid #dddddd;
        }

        h2 {
            font-size: calcRem(18);

            span {
                font-size: calcRem(18);
                text-transform: uppercase;
            }
        }
    }

    .footer-note {
        &{
            font-size: calcRem(15);
            color: #999999;
            font-weight: 700;
            margin-top: 30px;
        }

        p {
            &{
                font-size: calcRem(12);
                color: #999999;
                font-weight: 500;
                margin: 0;
            }

            i {
                font-size: 5px;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }

    .ticket-payment {

        &{
            text-align: center;
        }

        .justify-content-center {
            margin-top: 40px;
            margin-bottom: 30px;
        }

        h5 {
            color: #02ACEF;
            font-size: calcRem(30);
            font-weight: 700;
            display: inline-block;
            vertical-align: middle;
        }

        .btn {
            &-primary {
                background-color: $btn-invest;
                font-size: calcRem(18);
                text-transform: uppercase;
                border: none;
                font-weight: 700;
                padding: calcRem(10) calcRem(50);
                display: inline-block;
                vertical-align: middle;

                &[disabled] {
                  background-color: #ccc !important;
                  color: #fff !important;
                }

                &:hover {
                    background: darken($btn-invest, 5%);
                }
            }
        }

        p {
            &{
                display: inline-block;
                text-align: center;
                vertical-align: middle;
                width: 70%;
                font-size: 1rem;
                margin-bottom: 0;
                margin-left: 5px;
                color: #000;
            }

            i {
                margin-right: 5px;
            }

            span {
                font-weight: 700;
            }

            &.small {
              font-size: 0.7rem;
            }
        }
    }

    .box-col {
        &{
            border: 1px solid #dddddd;
            border-radius: 5px;
            padding: 15px 30px;
            min-height: 200px;
        }

        .table {

            th {
                color: #666;

                a {
                    color: #02ACEF;
                    margin-left: 5px;
                }
            }

            td {
                color: #02ACEF;
                font-weight: 700;
            }
        }

        ul {
            li {

                &{
                    color: #777777;
                }

                &:first-child {
                    font-weight: 700;
                    font-size: calcRem(20);
                }

                &:nth-child(2) {
                    text-transform: uppercase;
                }

                &:last-child {
                    a {
                        font-size: calcRem(14);
                        color: #777777;
                        text-decoration: underline !important;
                    }
                }
            }
        }

        &-table {
            padding-left: 10px;
            padding-right: 10px;
        }

        &-list {
            background-color: #f7f7f7;
        }

        &-p {
            &{
                padding: 30px 50px;
                border-color: #FFEEBA;
                background-color: #FFF3CD;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;


                @include brkp-01(1500px) {
                    min-height: inherit;
                    margin-top: 1rem;
                }
            }

            p {
                color: #856404;

                span {
                    font-weight: 700;
                }
            }
        }
    }

    .modal-header {
        .tit_page {
            margin-bottom: 0;
        }

        div {
            width: 100%;
        }

        h2 {
            color: #434371;
            font-size: calcRem(30);
        }

        hr {
            margin-bottom: 0;
        }
    }

    .modal-body {
        .bordered {
            &{
                border: 1px solid #DDDDDD;
                padding: 20px;
                border-radius: 5px;
            }

            .table {

                th {
                    font-weight: 700;
                }

                td {
                    &{
                        color: #666;
                    }

                    span {
                        &:not(.box){
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }

                .rating {
                    span {
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        vertical-align: middle;
                    }
                }
            }
        }

        .td-total {
            &{
                padding: 0 20px;
                margin-top: 20px;
                margin-right: 20px;
                background-color: #EEEEEE;
                border-radius: 5px;
            }

            .table {
                &{}

                th {
                    &{
                        color: #666666;
                        font-size: calcRem(18);
                        font-weight: 400;
                         padding-top: 20px;
                    }
                }

                tr {
                    &{
                        border-bottom:1px solid #dddddd !important;
                    }
                }

                td {
                    &{
                        color: #02ACEF;
                        font-size: calcRem(30);
                        font-weight: 700;
                        padding-bottom: 20px;
                        border-top: 1px solid #dddddd;
                    }
                }
            }
        }
    }
</style>

<script>
import WalletInvestiment from '../services/api/investiment';
// import MarketingDrip from '../services/api/marketing';
import IouuPay from '../services/api/iouuPay';
import * as mutationTypes from '@/store/mutation-types.js'
import ApiClient from '../utils/api-client'
import PayClient from '../utils/pay-client'
import Modal from '@/components/Modal'
import Masker from '../utils/masker'
import Swal from 'sweetalert2'
import axios from 'axios'

	export default {
        data() {
            return {
                Valor:0,
                ValorReinv:0.0,
                InvestidorId: "",
                reservaId: "",
                solicitacao: null,
                score:null,
                submit:false,
                TipoUser: '',
                investimentos: '',
                suitability: '',
                investidor: '',
                sexo: '',
                estadoCivil: '',
            }
        },
        methods: {
            FormatCurrency(value) {
                if(value != null)
                    return "R$ " + value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

                return 0;
            },
            ScoreClass(score) {
                if (score == null || score == undefined) return "";
                return `rating-${score.toLowerCase()}`
            },
            Score(score) {
                if (score == null || score == undefined) return "";

				if (score == "AA" || score == "HR") return score;

				return score.substr(0, 1);
            },
            NomeTomador() {
                return `${this.solicitacao.Empresa.NomeFantasia} - ${Masker.maskCnpj(this.solicitacao.Documento)}`
            },
            TipoInvestimento() {
                switch(this.solicitacao.CodProduto){
                    case "EMPCOL":
                        return "Empréstimo Coletivo"
                    case "EMPIMP2":
                        return "Empréstimo Impacto"
                    case "EMPIMP":
                        return "Empréstimo Impacto"
                    default:
                        return ""
                }
            },
            Redirect(type) {
                if(type === "lista") {
                    this.$router.push("/investimentos/oportunidades")
                } else {
                    this.$router.push(`/investimentos/oportunidades/perfil-empresa/${this.solicitacao._id}`)
                }
            },
            GeraSwal(titulo, msg){
                Swal.fire({
                    title: titulo,
                    text: msg,
                    type: 'info',
                    confirmButtonColor: '#40CD28',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.value) {
                        this.$router.push('/investimentos/oportunidades/perfil-empresa/'+this.solicitacao._id)
                    }
                })
            },
            GeraSwalSocial(titulo, msg){
                Swal.fire({
                    title: titulo,
                    text: msg,
                    type: 'info',
                    confirmButtonColor: '#40CD28',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.value) {
                        this.$router.push('/investimentos/investimento-de-impacto/perfil-social-new/'+this.solicitacao._id)
                    }
                })
            },
            async SubmitInvestment() {
                if(!this.submit){
                    this.$store.commit(mutationTypes.START_LOADING);

                    this.submit = true

                    let dataVencimento = new Date();
                    dataVencimento.setDate(dataVencimento.getDate() + 1);
                    
                    let investmentReservation = {
                        Valor: this.Valor,
                        ReInvestimento: this.ValorReinv,
                        Boleto: {}
                    }
                    
                    let priceCents = (this.Valor - this.ValorReinv) * 100
                    let boleto = {
                        Boleto: {
                            due_date: dataVencimento,
                            email: this.$store.state.currentUser.email,
                            items: [{
                                description: "Oportunidade: #" + this.solicitacao.IdOportunidade + " " + this.solicitacao.Empresa.NomeFantasia,
                                quantity: 1,
                                price_cents: parseInt(priceCents.toFixed(2))
                            }]
                        }
                    }
                    
                    if(this.solicitacao.TipoEmprestimo == "emprestimo-social") {

                        var titulo = 'Investimento confirmado com sucesso!',
                            msg = "Você será redirecionado para a página de perfil da empresa."
                        let reserva = await WalletInvestiment.CreateReservation(this.solicitacao._id, investmentReservation);
                        this.GeraSwalSocial(titulo, msg)
                        return
                    }

                    var titulo = 'Não foi possível gerar seu boleto',
                        msg = "Você será redirecionado para a página de perfil da empresa. Entre em contato com nossos atendentes para gerar uma segunda via."

                    try {
                        //GERAR RESERVA DE INVESTIMENTO
                        let reserva = await WalletInvestiment.CreateReservation(this.solicitacao._id, investmentReservation);
                        //GERAR BOLETO
                        let boletoInvestidor = process.env.FEAT_ABC == "true" ?
                            await IouuPay.CreateBoleto(reserva.data._id) :
                            await WalletInvestiment.CreateBoleto(reserva.data._id, boleto)

                        if(process.env.FEAT_ABC == "true") {
                            let reservaID = {
                                reservaID: reserva.data._id
                            }
                            await WalletInvestiment.CreateInvestDepositRecord(reservaID);
                            await WalletInvestiment.CreateInvestDebtRecord(reservaID);
                        }

                        this.$store.commit(mutationTypes.STOP_LOADING)
                        if(boletoInvestidor.statusText == "OK" || typeof boletoInvestidor.data != "undefined") {
                            this.$router.push(`/investimentos/finalizar-investimento?id=${reserva.data._id}`)

                            // if(process.env.NODE_ENV === "production") {
                            //     let now = new Date();
                                
                            //     _dcq.push(
                            //         [
                            //             "track", this.solicitacao.Empresa.NomeFantasia + " (ID: #" + this.solicitacao.IdOportunidade + ")",
                            //             { 
                            //                 occurred_at: now,
                            //                 value: this.Valor
                            //             }
                            //         ]
                            //     );

                            //     var properties = {
                            //         "subscribers": [{
                            //             "email": this.User.email,
                            //             "time_zone": "America/Sao_Paulo",
                            //             "user_id": this.User._id,
                            //             "first_name": this.User.first_name,
                            //             "last_name": this.User.last_name,
                            //             "phone": this.User.investor.TelefoneFixo,
                            //             "city": this.User.investor.Endereco.Cidade,
                            //             "state": this.User.investor.Endereco.Uf,
                            //             "tags": ["Investidor (Cliente)"],
                            //             "custom_fields": {
                            //                 "Tipo": this.TipoUser,
                            //                 "Perfil_Suitability": this.User.suitability.Tipo,
                            //                 "Preencheu_Suitability": this.suitability,
                            //                 "Investidor": this.investidor,
                            //                 "Tem_Investimentos": this.investimentos,
                            //                 "Sexo": this.sexo,
                            //                 "Estado_Civil": this.estadoCivil,
                            //                 "Renda_Mensal": this.User.investor.RendaMensal,
                            //                 "Patrimonio_Declarado": this.User.investor.Patrimonio
                            //             }
                            //         }]
                            //     }
                                
                            //     await MarketingDrip.DripSubscribers(properties);

                            //     console.log("DRIP ", _dcq)
                            // }

                            this.$store.commit(mutationTypes.STOP_LOADING)
                        } else if (typeof reserva.data == "undefined") {
                            titulo = 'Não foi possível gerar sua reserva'
                            msg = "Você será redirecionado para a página de perfil da empresa. Caso o erro persista entre em contato com nossos atendentes."
                            this.GeraSwal(titulo, msg)
                        } else {
                            this.GeraSwal(titulo, msg)
                            this.$store.commit(mutationTypes.STOP_LOADING)
                        }
                        
                    } catch(error) {
                        try{
                            titulo = error.response.data.errors[0].detail
                        }catch(err){
                            titulo = 'Não foi possível gerar sua reserva'
                        }

                        this.$store.commit(mutationTypes.STOP_LOADING)
                        
                        this.GeraSwal(titulo, msg)
                    }
                }
            },

            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/oportunidades/confirmacao/:id',
                    title: 'Checkout',
                })
            },
        },
        async created() {
            this.User = this.$store.state.currentUser

            if (this.User.tipo.length > 1) {
                this.TipoUser = 'Investidor e Tomador'
            } else if (this.User.tipo[0] === 'INV') {
                this.TipoUser = 'Investidor'
            } else {
                this.TipoUser = 'Tomador'
            }

            this.User.hassuitability === true ? this.suitability = 'Verdadeiro' : this.suitability = 'Falso'
            this.User.hasinvestor === true ? this.investidor = 'Verdadeiro' : this.investidor = 'Falso'
            this.User.hasinvestments === true ? this.investimentos = 'Verdadeiro' : this.investimentos = 'Falso'
            if (this.User.investor.Sexo === 1) {
                this.sexo = 'M'
            } else if (this.User.investor.Sexo === 2) {
                this.sexo = 'F'
            }

            if (this.User.investor.EstadoCivil === 1) {
                this.estadoCivil = 'Solteiro (a)'
            } else if (this.User.investor.EstadoCivil === 2) {
                this.estadoCivil = 'Casado (a)'
            } else if (this.User.investor.EstadoCivil === 3) {
                this.estadoCivil = 'Divorciado (a)'
            } else if (this.User.investor.EstadoCivil === 4) {
                this.estadoCivil = 'Viúvo (a)'
            } else if (this.User.investor.EstadoCivil === 5) {
                this.estadoCivil = 'União Estável'
            }

            //tagueamento GA
            await this.taggingGA();   
        },
        async beforeMount() {
            this.$store.commit(mutationTypes.START_LOADING);

            let preInv = JSON.parse(localStorage.getItem("pre_investimento"))

            if (preInv == null) { 
                this.$router.push("/investimentos/oportunidades")
            }else{
                this.ValorReinv = preInv.ValorReinvestimento
                this.Valor = preInv.Valor
                this.InvestidorId = preInv.InvestidorId
                console.log("CHECK..", preInv)
                try {
                    this.solicitacao = await ApiClient.getLoanRequest(preInv.SolicitacaoId)
                    this.score = this.Score(this.solicitacao.Score)
                    this.$store.commit(mutationTypes.STOP_LOADING)
                } catch(error) {
                    console.log(error)
                    this.$store.commit(mutationTypes.STOP_LOADING)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Checkout.vue